import { useEffect } from 'react'

interface DataEffectParams<T> {
    data: T
    isLoading: boolean
    error: any
    onDataFetched: (data: T) => void
}

export function useMergeChainDataEffect<T>({
    data,
    isLoading,
    error,
    onDataFetched,
}: DataEffectParams<T>) {
    useEffect(() => {
        if (!isLoading && !error) {
            onDataFetched(data)
        }
    }, [isLoading, error])
}
